import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const FIFTEEN_MINUTES_IN_MS = 900000;

// Thunk to fetch a new SAS token
export const fetchSasToken = createAsyncThunk(
  "documents/sasToken", 
  async ({ controller }: { controller }, { getState }) => {
  const response = await axios.get(`/sas-token`, {
    signal: controller.signal,
  });
  const responseData = response.data;
  const query = responseData.includes('?') ? responseData.split('?')[1] : responseData;
  sessionStorage.setItem("sasToken", query);
  return query;
});

// Utility thunk to ensure a valid SAS token
export const getValidSasToken = createAsyncThunk(
  "documents/getValidSasToken",
  async (_, { dispatch, getState }) => {
    const state = getState() as any;
    const sasTokenExpiry = new URLSearchParams(state.documents.sasToken).get("se");
    // Check if the token is still valid
    if (sasTokenExpiry && new Date(sasTokenExpiry).getTime() > new Date().getTime() + FIFTEEN_MINUTES_IN_MS) {
      return state.documents.sasToken; // Return the current token if valid
    }
    // Otherwise, fetch a new token
    const controller = new AbortController();
    return await dispatch(fetchSasToken({ controller })).unwrap();
  }
);

// Then, handle actions in your reducers:
const documentsSlice = createSlice({
  name: "documents",
  initialState: {
    sasToken: sessionStorage.getItem("sasToken") || '',
  },
  reducers: {},
  extraReducers: {
    [fetchSasToken.fulfilled.type]: (state, action) => {
      state.sasToken = action.payload;
    },
  },
});

export default documentsSlice.reducer;